import { render, staticRenderFns } from "./PaymentTypeNew_Details.vue?vue&type=template&id=a216fe76&"
import script from "./PaymentTypeNew_Details.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports